import type { ScrapingIntentSummary } from '../types';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
// periodic 전용: 스케줄링을 멈추기 (더이상 run을 생성하지 않는다)
export async function deactivateScrapingIntent(intentId: string): Promise<ScrapingIntentSummary> {
  const response = await internalApiClient.patch<ScrapingIntentSummary>(
    `scraping-intents/${intentId}`,
  );

  return response.json();
}
